.windyEmbed {
  &__container {
    padding: 15px 0;
  }

  &__iframe {
    aspect-ratio: 4 / 3;
    border: 0;
    width: 100%;
  }
}
